import { useQuery } from '@tanstack/react-query';
import { useDataChainId } from '@ui/hooks/datachain';
import { usePublicClient } from 'wagmi';

import { getPythUpdateFee } from './query';

export const usePythUpdateFee = ({
  pythUpdateData,
}: {
  pythUpdateData: string[] | undefined;
}) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    enabled: !!pythUpdateData && !!client?.uid,
    queryKey: getPythUpdateFee.getQueryKey({
      chainId,
      clientUid: client?.uid || '',
      pythUpdateData: pythUpdateData ?? [],
    }),
    queryFn: getPythUpdateFee.getQueryFn({
      client: client,
      pythUpdateData: pythUpdateData ?? [],
      chainId,
    }),
  });
};
